// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type DownloadSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function DownloadSvgrepoComsvgIcon(
  props: DownloadSvgrepoComsvgIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      x={"0"}
      y={"0"}
      viewBox={"0 0 211.293 211.293"}
      xmlSpace={"preserve"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M176.777 54.027H133.43a7.499 7.499 0 00-7.5 7.5 7.5 7.5 0 007.5 7.5h35.848v127.266H42.016V69.027H77.86c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5H34.516a7.5 7.5 0 00-7.5 7.5v142.266a7.5 7.5 0 007.5 7.5h142.262c4.143 0 7.5-3.357 7.5-7.5V61.527a7.501 7.501 0 00-7.501-7.5z"
        }
      ></path>

      <path
        d={
          "M82.058 101.468a7.5 7.5 0 00-10.606-.001 7.5 7.5 0 00-.001 10.607l28.889 28.89a7.5 7.5 0 0010.607.001l28.891-28.89a7.498 7.498 0 00.001-10.606 7.5 7.5 0 00-10.606-.001l-16.088 16.087V7.5c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v110.054l-16.087-16.086z"
        }
      ></path>
    </svg>
  );
}

export default DownloadSvgrepoComsvgIcon;
/* prettier-ignore-end */
